import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@/lib/api";

/** Persist a real card/CV open; list reads never acknowledge candidates. */
export function useMarkColdCandidateViewed(
  vacancyId: string | null | undefined,
  candidateId: string | undefined,
): () => void {
  const qc = useQueryClient();
  const { mutate } = useMutation({
    mutationFn: async () => {
      if (!vacancyId || !candidateId) return;
      await api.post(
        `/api/v1/vacancies/${vacancyId}/cold-search-results/${candidateId}/viewed`,
      );
    },
    retry: 2,
    onSuccess: () => {
      void qc.invalidateQueries({
        queryKey: ["cold-search-accumulated", vacancyId],
      });
    },
  });
  return mutate;
}
